// extracted by mini-css-extract-plugin
module.exports = {"desktopPlayer":"_normal--desktopPlayer--4ZqtU","active":"_normal--active--3j3fC"};